import React, { Component } from 'react';

import './cambiarPlan.css';
import '../consumoHome.css';

import IconMoney from '../../../../img/IconMoney.svg';

class CambiarPlan extends Component {

    constructor(){
        super();
        this.state = {
           
        };
    }

    render(){
        return(
            <div className='col s12'>
                <div className='card-panel cardConsumo cambiarPlanCard'>
                    <img src={IconMoney} alt='iconmoney'/>
                    <div className='contenidoPlanInfo'>
                        <p>Intermedio</p>
                        <p>US $160 / mes</p>
                        <p>Incluye 250 sesiones mensuales</p>
                        <p>US $26 cada 10 sesiones extra</p>
                        <div className='btnPlanDiferente'>
                            <p>Cambiar Plan</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CambiarPlan;
